import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { CompanyDto } from './company-dto.model';
import { ProjectDto } from './project-dto.model';
import { ThumbApplicationFromType } from '../service-proxies';


export class ThumbInOutDetailsDto implements IThumbInOutDetailsDto {
    eventDate!: Date | undefined;
    inDateTime!: Date | undefined;
    outDateTime!: Date | undefined;
    presentTime!: Date | undefined;
    employee!: EmployeeSummaryDto;
    dailyCount!: number;
    empLegalName!: string | undefined;
    company!: CompanyDto;
    project!: ProjectDto;
    thumbApplicationFromType!: ThumbApplicationFromType;
    thumbApplicationFromTypeName!: string | undefined;
    thumbRemark!: string | undefined;

    constructor(data?: IThumbInOutDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.inDateTime = _data["inDateTime"] ? new Date(_data["inDateTime"].toString()) : <any>undefined;
            this.outDateTime = _data["outDateTime"] ? new Date(_data["outDateTime"].toString()) : <any>undefined;
            this.presentTime = _data["presentTime"] ? new Date(_data["presentTime"].toString()) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.dailyCount = _data["dailyCount"];
            this.empLegalName = _data["empLegalName"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.thumbApplicationFromType = _data["thumbApplicationFromType"];
            this.thumbApplicationFromTypeName = _data["thumbApplicationFromTypeName"];
            this.thumbRemark = _data["thumbRemark"];
        }
    }

    static fromJS(data: any): ThumbInOutDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThumbInOutDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["inDateTime"] = this.inDateTime ? this.inDateTime.toISOString() : <any>undefined;
        data["outDateTime"] = this.outDateTime ? this.outDateTime.toISOString() : <any>undefined;
        data["presentTime"] = this.presentTime ? this.presentTime.toISOString() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["dailyCount"] = this.dailyCount;
        data["empLegalName"] = this.empLegalName;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["thumbApplicationFromType"] = this.thumbApplicationFromType;
        data["thumbApplicationFromTypeName"] = this.thumbApplicationFromTypeName;
        data["thumbRemark"] = this.thumbRemark;
        return data; 
    }
}

export interface IThumbInOutDetailsDto {
    eventDate: Date | undefined;
    inDateTime: Date | undefined;
    outDateTime: Date | undefined;
    presentTime: Date | undefined;
    employee: EmployeeSummaryDto;
    dailyCount: number;
    empLegalName: string | undefined;
    company: CompanyDto;
    project: ProjectDto;
    thumbApplicationFromType: ThumbApplicationFromType;
    thumbApplicationFromTypeName: string | undefined;
    thumbRemark: string | undefined;
}

